import { RunwayModelsResponse } from '@/types';

export const UPDATE_AUTOMATIONS = 'UPDATE_AUTOMATIONS';

export interface UpdateAutomationsAction {
    type: typeof UPDATE_AUTOMATIONS;
    payload: RunwayModelsResponse['automations'];
}

export const updateAutomations = (payload: RunwayModelsResponse['automations']): UpdateAutomationsAction => {
    return {
        type: UPDATE_AUTOMATIONS,
        payload: payload,
    };
};
